module.exports = "../study/imgs/maps/Kanagawa/GWQ8/Climate/SnowFall/Kanagawa_SnowFall_MRI_RCP85_End.png";